import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@material-ui/core'

import './index.scss'

const ConfirmSend = ({
    isOpen, onClose, shouldSave, timeInWorkingHours
}) => (
    <div className='ConfirmSend'>
        <Dialog
            classes={{
                root: 'ConfirmSend__root',
            }}
            open={isOpen}
            onClose={() => onClose(false)}
        >
            <DialogTitle>Warning</DialogTitle>
            <DialogContent>
                {!timeInWorkingHours() && (
                    <div className='Appointment__error'>
                        Violating appointment conditions
                    </div>
                )}
                <p>
                    {/* Date and Time is written in the <b>appointment</b> box,
                        do you want to reply to with this data? */}
                    Appointment details are written in the
                    <b> appointment </b>
                    box, do you want to reply to with this data?
                </p>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(false)}>Cancel</Button>
                <Button
                    color='primary'
                    onClick={() => onClose(true)}
                    disabled={!timeInWorkingHours()}
                >
                    {shouldSave ? 'Just Save and HTO' : 'Send'}
                </Button>
            </DialogActions>
        </Dialog>
    </div>
)

export default React.memo(ConfirmSend)
